import { render, staticRenderFns } from "./ExternalLocations.vue?vue&type=template&id=054a92f0"
import script from "./ExternalLocations.vue?vue&type=script&lang=js"
export * from "./ExternalLocations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports